/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthLoginGoogleResponse } from './AuthLoginGoogleResponse';

export type AuthLoginGoogleResponseApiRespoonse = {
    data?: AuthLoginGoogleResponse;
    status?: AuthLoginGoogleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuthLoginGoogleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

